import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Table, Button } from "react-bootstrap";
import {
  handleFieldChange,
  fetchTimesheets,
  upsertTimesheet,
  addTimesheetDate,
  addRow,
  enterTimeEntries,
  updateTimeEntries,
  resetTimesheetDates,
  getTimesheetEntries,
  changeStatus,
  deleteTimeEntryByRow,
  PENDING,
  DRAFT,
  REJECTED,
  APPROVED,
  NEW,
  WORK_HOURS,
} from "../../store/actions/timesheet/timesheetActions";
import { fetchProjects } from "../../store/actions/projects/projectsActions";
import {
  toggleDialogBox,
  togglePrompt,
} from "../../store/actions/commonActions";
import { fetchApprovals } from "../../store/actions/timesheet/approvalsActions";
import {
  TEAM_LEADER,
  MANAGER,
  PORTAL_ADMIN,
  fetchNonICRoles,
  setDefaultRole,
} from "../../store/actions/users/usersActions";
import "../../css/timesheets.css";

import TimesheetForm from "./TimesheetForm";
import TimesheetConfirmations from "./TimesheetConfirmations";
import TotalDayHoursSpent from "./TotalDayHoursSpent";
import WeeksDropdown from "./WeeksDropdown";
import RequestBudgetForm from "./RequestBudgetForm";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";

import { Cache } from "aws-amplify";
import moment, { duration } from "moment";

import {
  ERROR_ALERT,
  toggleShowAlert,
} from "../../store/actions/commonActions";
import {
  fetchHolidays,
  isHoliday,
} from "../../store/actions/holidays/holidaysActions";

import PageTitle from "../../common/PageTitle";

class AddTimesheet extends Component {
  constructor(props) {
    super(props);
    this.action = "";
    this.confirmAction = "";
    this.status = "";
    this.submitButtonText = "Send to Approver";
    this.draftButtonText = "Save as Draft";
    this.approveButtonText = "Approve";
    this.rejectButtonText = "Reject";
    this.readOnly = false;
    this.submitSelector = "submitButton";
    this.userId = "";
    this.roleId = "";
    this.timesheetId = 0;
  }

  componentDidMount() {
    const userId = Cache.getItem("userId");
    this.roleId = Cache.getItem("roleId");
    const currentUser = this.props.users.currentUser;

    this.props.fetchProjects();
    this.props.fetchTimesheets();
    this.props.fetchApprovals(userId);
    const pathname = this.props.location.pathname;
    if (
      pathname === "/timesheet/update" ||
      pathname === "/timesheet/approval"
    ) {
      if (pathname === "/timesheet/update") {
        this.action = "UPDATE_TIMESHEET";
      } else {
        this.action = "TIMESHEET_APPROVAL";
      }

      const urlParams = new URLSearchParams(this.props.location.search);

      this.timesheetId = +urlParams.get("id");
      const paramRoleId = +urlParams.get("role_id");

      if (
        paramRoleId &&
        this.roleId !== +paramRoleId &&
        this.action === "TIMESHEET_APPROVAL"
      ) {
        let role = null;

        if (currentUser && typeof currentUser.roles !== "undefined") {
          const userRoles = currentUser.roles;

          userRoles.length &&
            userRoles
              .filter((data) => {
                if (data.id === +paramRoleId) {
                  return data;
                }
                return false;
              })
              .forEach((userRole) => {
                role = userRole;
              });
        }

        if (role) {
          this.props.setDefaultRole(role);
          this.roleId = +paramRoleId;
        }
      }

      this.props.getTimesheetEntries(this.timesheetId);
    } else {
      this.action = "ENTER_TIMESHEET";
    }
    this.userId = userId;

    if (this.action === "TIMESHEET_APPROVAL") {
      const allowedRoles = fetchNonICRoles();

      if (!allowedRoles.includes(this.roleId)) {
        this.props.history.push("/");
      }
    }
  }

  componentWillUnmount() {
    this.props.resetTimesheetDates();
  }

  getWeeks = () => {
    let weeksList = [];
    const weeks = this.props.common.weeksInYear;

    weeksList = weeks.map((week, key) => {
      return (
        <option key={key} value={week.week_num}>
          {week.start} - {week.end}
        </option>
      );
    });

    return weeksList;
  };

  otChecker = () => {
    const otEntries = this.props.timesheets.overTimeEntries;
    const durationEntries = this.props.timesheets.durationEntries;

    let passed = false;
    let isOt = false;
    let message = "";

    if (durationEntries && durationEntries.length) {
      let durationPerDay = {};
      let otInputPerDay = {};

      let parsedEntries = {};

      for (const entry of durationEntries) {
        if (entry.duration < 0) {
          return "Please do not enter negative values";
        }

        if (!(entry.date in durationPerDay)) {
          durationPerDay[entry.date] = 0;
        }

        durationPerDay[entry.date] =
          durationPerDay[entry.date] + +entry.duration;
      }

      // Round durationPerDay to 2 decimal places
      for (const date in durationPerDay) {
        durationPerDay[date] = +(durationPerDay[date].toFixed(2));
      }

      for (const otEntry of otEntries) {
        if (otEntry.otHours < 0) {
          return "Please do not enter negative values";
        }

        if (!(otEntry.entryDate in otInputPerDay)) {
          otInputPerDay[otEntry.entryDate] = 0;
        }

        if (otEntry.otHours > 0) isOt = true;

        otInputPerDay[otEntry.entryDate] += otEntry.otHours;
      }

      // Round otInputPerDay to 2 decimal places
      for (const date in otInputPerDay) {
        otInputPerDay[date] = +(otInputPerDay[date].toFixed(2));
      }

      const days = Object.keys(otInputPerDay);

      for (const day of days) {
        if (!(day in parsedEntries)) {
          parsedEntries[day] = { total: 0, otHours: 0 };
        }

        parsedEntries[day] = {
          total: durationPerDay[day],
          otHours: otInputPerDay[day],
        };

        const hoursToFile = durationPerDay[day] - WORK_HOURS;

        if (hoursToFile.toFixed(2) === otInputPerDay[day].toFixed(2)) {
          passed = true;
        }

        message = `Total overtime hours should be less than or equal to ${hoursToFile.toFixed(
          2
        )} hours.`;
      }
    }

    return { passed, isOt, message };
  };

  generateDateRange = () => {
    const selectedWeek = this.props.timesheets.selectedWeek;
    let startDate = "";
    let endDate = "";

    if (Object.keys(selectedWeek).length > 0) {
      startDate = selectedWeek.start;
      endDate = selectedWeek.end;

      startDate = new Date(startDate);
      endDate = new Date(endDate);

      var loop = new Date(startDate);

      let isUpdate = false;
      if (
        this.action === "UPDATE_TIMESHEET" ||
        this.action === "TIMESHEET_APPROVAL"
      ) {
        isUpdate = true;
      }

      while (loop <= endDate) {
        this.props.addTimesheetDate(loop, 1, isUpdate);
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }
    }
  };

  generateDateHeaders = () => {
    const timesheetDates = this.props.timesheets.timesheetDates;
    const dateHeaders =
      timesheetDates.length > 0 &&
      timesheetDates.map((date, key) => {
        const month = date.month;
        const numDate = date.numDate;
        return (
          <th key={key} width="5%" className="align-center">
            {month}/{numDate}
            {"\n"}
            {date.day}
          </th>
        );
      });

    return dateHeaders;
  };

  generateTimesheetForm = () => {
    let initRows = [];
    let afterRows = [];

    this.props.timesheets.timesheetEntries.forEach((timeEntry) => {
      initRows.push(
        <TimesheetForm
          key={timeEntry.entry_id}
          entry_id={timeEntry.entry_id}
          action={this.action}
          isFirstRow={!initRows.length}
          readOnly={this.readOnly}
          static={
            timeEntry.project_id === 1 || timeEntry.project_id === 0
              ? false
              : true
          }
          formGroup={"init"}
        />
      );
    });

    this.props.timesheets.additionalTimeEntries.forEach((timeEntry) => {
      afterRows.push(
        <TimesheetForm
          key={timeEntry.entry_id}
          entry_id={timeEntry.entry_id}
          action={this.action}
          isFirstRow={!afterRows.length}
          readOnly={this.readOnly}
          static={false}
          formGroup={"additional"}
        />
      );
    });

    return [...initRows, ...afterRows];
  };

  validateRequiredFields = () => {
    const { timesheetEntries } = this.props.timesheets;
  
    for (const entry of timesheetEntries) {
      if (!entry.project_id) return "Please make sure each row has a Project selected";
      if (!entry.task_id) return "Please make sure each row has a Task selected";
    }
  
    return "";
  };
  
  validateDurations = () => {
    const { durationEntries } = this.props.timesheets;
    let durationPerDay = {};
  
    for (const entry of durationEntries) {
      if (entry.duration < 0) return "Please do not enter negative values";
  
      if (!durationPerDay[entry.date]) durationPerDay[entry.date] = 0;
      durationPerDay[entry.date] += +entry.duration;
    }

    // Round to 2 decimal places to avoid floating point precision issues
    for (const date in durationPerDay) {
      durationPerDay[date] = +(durationPerDay[date].toFixed(2));
    }
  
    return { durationPerDay };
  };
  
  validateWorkHours = (durationPerDay) => {
    for (const date in durationPerDay) {
      const isHoliday = this.props.isHoliday(date);
      const totalHours = +durationPerDay[date].toFixed(2);
  
      if (
        moment(date).isSameOrBefore(moment()) &&
        !isHoliday &&
        totalHours < WORK_HOURS
      ) {
        return `Please make sure each work day meets ${WORK_HOURS} work hours`;
      }
    }
    return "";
  };
  
  // old
  // validateOvertimeTags = () => {
  //   const { durationEntries, overTimeEntries } = this.props.timesheets;
  
  //   for (const date in durationEntries) {
  //     const totalHours = +durationEntries[date].toFixed(2);
  //     const isWeekend = moment(date).day() === 0 || moment(date).day() === 6;
  
  //     if (totalHours > WORK_HOURS || (isWeekend && totalHours > 0)) {
  //       const matchingOTs = overTimeEntries.filter((o) => o.entryDate === date);
  //       const hasTag = matchingOTs.some((o) => o.isTag);
  //       if (!hasTag) return "Please make sure to enter all overtime hours";
  //     }
  //   }
  
  //   return "";
  // };

  validateOvertimeTags = () => {
    const { overTimeEntries } = this.props.timesheets;
    const { durationPerDay } = this.validateDurations(); // reuse the logic!
  
    for (const date in durationPerDay) {
      const totalHours = +durationPerDay[date].toFixed(2);
  
      if (totalHours > WORK_HOURS) {
        const matchingOTs = overTimeEntries.filter((o) => o.entryDate === date);
        const hasTag = matchingOTs.some((o) => o.isTag);
        if (!hasTag) return "Please make sure to enter all overtime hours";
      }
    }
  
    return "";
  };
  
  
  validateOvertimeLimit = (durationPerDay) => {
    const { overTimeEntries } = this.props.timesheets;
  
    for (const date in durationPerDay) {

      if (!date || date === "undefined") continue;  // skip invalid keys

      const isHoliday = this.props.isHoliday(date);
      if (isHoliday) continue;

      console.log("Date", date);
      const totalHours = +(durationPerDay[date].toFixed(2));
      const hoursToFile = totalHours - WORK_HOURS;
      const allowableOT = Math.max(0, +(hoursToFile.toFixed(2)));
  
      const totalOT = overTimeEntries
        .filter((ot) => ot.entryDate === date)
        .reduce((sum, ot) => sum + ot.otHours, 0);
      const roundedTotalOT = +(totalOT.toFixed(2));

      if (roundedTotalOT > allowableOT) {
        return "You have exceeded overtime hours in your timesheet.";
      }
    }
  
    return "";
  };
  
  validateWeekCompletion = () => {
    const { durationEntries } = this.props.timesheets;
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDayOfWeek);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
  
    for (const entry of durationEntries) {
      const entryDate = new Date(entry.date);
      if (entryDate >= startOfWeek && entryDate <= endOfWeek) {
        if (currentDayOfWeek !== 5) {
          return "You cannot send to approvers until the current week is over.";
        }
      }
    }
  
    return "";
  };
  
  validateTimesheet = () => {
    const requiredFieldsError = this.validateRequiredFields();
    if (requiredFieldsError) return requiredFieldsError;
  
    const { durationPerDay } = this.validateDurations();
    const workHourError = this.validateWorkHours(durationPerDay);
    if (workHourError) return workHourError;
  
    const overtimeTagError = this.validateOvertimeTags();
    if (overtimeTagError) return overtimeTagError;
  
    const overtimeLimitError = this.validateOvertimeLimit(durationPerDay);
    if (overtimeLimitError) return overtimeLimitError;
  
    const weekCompletionError = this.validateWeekCompletion();
    if (weekCompletionError) return weekCompletionError;
  
    return "";
  };

  displayTimesheetButtons = () => {
    const initEntries = this.props.timesheets.timesheetEntries;
    const additionalEntries = this.props.timesheets.additionalTimeEntries;
    const entries = [...initEntries, ...additionalEntries];
    let isFirstEmpty = false;

    if (entries[0]) {
      if (entries[0].project_id === 0 || entries[0].task_id === 0) {
        isFirstEmpty = true;
      }
    }
    if (this.status === PENDING) {
      if (this.action === "TIMESHEET_APPROVAL") {
        return (
          <Row className="float-right mb-5">
            <Col>
              <Button
                size="sm"
                className="mr-1"
                variant="success"
                id="approveButton"
                onClick={() => {
                  this.confirmAction = "APPROVE_TIMESHEET";
                  this.props.togglePrompt(true);
                }}
              >
                {this.approveButtonText}
              </Button>
              <Button
                size="sm"
                className="mr-1"
                variant="danger"
                id="rejectButton"
                onClick={() => {
                  this.confirmAction = "REJECT_TIMESHEET";
                  this.props.togglePrompt(true);
                }}
              >
                {this.rejectButtonText}
              </Button>
            </Col>
          </Row>
        );
      }
      return "";
    }

    if (this.readOnly) {
      return "";
    }

    return (
      <Row>
        {/* <Col>
          <Button size="sm" id="requestBudgetBtn" className="t3-button" variant="default" onClick={() => {
            this.props.toggleDialogBox(true);
          }}>Request Budget</Button>
        </Col> */}
        <Col>
          <div className="float-right">
            <Button
              id="draftButton"
              size="sm"
              className="mr-1"
              variant="secondary"
              disabled={isFirstEmpty}
              onClick={() => {
                const selector = "draftButton";
                this.loadingButton(selector);

                if (this.action === "UPDATE_TIMESHEET") {
                  const entryIdsToDelete =
                    this.props.timesheets.entryIdsToDelete;
                  if (entryIdsToDelete.length > 0) {
                    this.props.deleteTimeEntryByRow(() => {
                      this.props.updateTimeEntries(
                        DRAFT,
                        this.timesheetSubmitted
                      );
                    });
                  } else {
                    this.props.updateTimeEntries(
                      DRAFT,
                      this.timesheetSubmitted
                    );
                  }

                  //If status is rejected, meaning it can be edited and returned back to Draft
                  if (this.status === REJECTED || this.status === APPROVED) {
                    this.props.changeStatus(DRAFT);
                    this.revertSubmitButton(selector);
                  }
                } else {
                  this.props.enterTimeEntries(DRAFT, this.timesheetSubmitted);
                }
              }}
            >
              {this.draftButtonText}
            </Button>
            <Button
              size="sm"
              id={this.submitSelector}
              disabled={isFirstEmpty}
              variant="primary"
              onClick={() => {
                const { passed, isOt, message } = this.otChecker();
                if (isOt && !passed) {
                  this.props.toggleShowAlert(true, ERROR_ALERT, message);
                  return false;
                }

                const errorMessage = this.validateTimesheet();
                if (errorMessage) {
                  this.props.toggleShowAlert(true, ERROR_ALERT, errorMessage);
                  return false;
                }

                this.loadingButton(this.submitSelector);

                if (this.action === "UPDATE_TIMESHEET") {
                  const entryIdsToDelete =
                    this.props.timesheets.entryIdsToDelete;
                  this.props.changeStatus(PENDING);

                  if (entryIdsToDelete.length > 0) {
                    this.props.deleteTimeEntryByRow(() => {
                      this.props.updateTimeEntries(
                        PENDING,
                        this.timesheetSubmitted
                      );
                    });
                  } else {
                    this.props.updateTimeEntries(
                      PENDING,
                      this.timesheetSubmitted
                    );
                  }
                } else {
                  this.props.enterTimeEntries(PENDING, this.timesheetSubmitted);
                }
              }}
            >
              {this.submitButtonText}
            </Button>
          </div>
        </Col>
      </Row>
    );
  };

  timesheetSubmitted = () => {
    this.props.history.push("/timesheet");
    this.revertSubmitButton(this.submitSelector);
  };

  loadingButton = (selector = "") => {
    if (!selector) {
      selector = "submitButton";
    }

    let progressVerb = "";
    switch (selector) {
      case "submitButton":
        progressVerb = "sending...";
        let draftButton = document.getElementById("draftButton");
        draftButton.disabled = true;
        break;
      case "draftButton":
        progressVerb = "saving...";
        let submitButton = document.getElementById("submitButton");
        submitButton.disabled = true;
        break;

      default:
        break;
    }

    let submitButton = document.getElementById(selector);
    submitButton.disabled = true;
    submitButton.textContent = progressVerb;
  };

  revertSubmitButton = (selector = "") => {
    if (!selector) {
      selector = "submitButton";
    }

    let submitButton = document.getElementById(selector);
    if (submitButton) {
      let finishVerb = "";
      let origText = "";
      switch (selector) {
        case "submitButton":
          finishVerb = "Sent!";
          origText = this.submitButtonText;
          break;
        case "draftButton":
          finishVerb = "Save!";
          origText = this.draftButtonText;
          break;

        default:
          break;
      }
      submitButton.disabled = false;
      submitButton.textContent = finishVerb;
      setTimeout(() => {
        submitButton.textContent = origText;
      }, 1000);
    }
  };

  displayAddRow = () => {
    if (
      (this.status !== NEW &&
        this.status !== DRAFT &&
        this.status !== REJECTED &&
        this.status !== APPROVED) ||
      this.readOnly
    ) {
      return "";
    }

    return (
      <tr>
        <td colSpan={11}></td>
        <td>
          <Button
            size="sm"
            variant="primary"
            id="t3-timesheet-add-row"
            onClick={() => {
              this.props.addRow();
            }}
          >
            <FontAwesomeIcon icon={faPlusSquare} />
          </Button>
        </td>
      </tr>
    );
  };
  renderTimesheetTable = () => {
    const timesheetDates = this.props.timesheets.timesheetDates;
    if (timesheetDates.length === 0) {
      return "";
    }
    let deleteRowHeader = null;
    if (
      (this.status === DRAFT ||
        this.status === NEW ||
        this.status === REJECTED ||
        this.status === APPROVED) &&
      !this.readOnly
    ) {
      deleteRowHeader = <th width="5%"> </th>;
    }

    let budgetHeader = "Budgeted Hours";
    let actualTimeHeader = "Actual Time Charges";
    let remainHeader = "Remaining Hours";
    const timeChargeHeader = "Time Charges for the Week";

    const roleId = Cache.getItem("roleId");
    if (this.action === "TIMESHEET_APPROVAL" && roleId === TEAM_LEADER) {
      //budgetHeader = '';
      //actualTimeHeader = '';
      //remainHeader = '';
    }

    let totalDayHoursSpent = <TotalDayHoursSpent readOnly={this.readOnly} />;
    //hide totals from pm when approving
    if (roleId === MANAGER && this.status === PENDING) {
      totalDayHoursSpent = "";
    }

    return (
      <>
        <Row>
          <Col>
            <Table>
              <thead>
                <tr className="p-0">
                  <td width="3%"> </td>
                  <th width="22%">Project</th>
                  <th width="25%">Task</th>
                  <th width="12%">
                    {actualTimeHeader} / {budgetHeader}
                  </th>
                  {this.generateDateHeaders()}
                  <th width="12%">
                    {timeChargeHeader} / {remainHeader}
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.generateTimesheetForm()}
                {this.displayAddRow()}
                {totalDayHoursSpent}
              </tbody>
            </Table>
          </Col>
        </Row>
        {this.displayTimesheetButtons()}
      </>
    );
  };

  displayRemarks = () => {
    const timesheet = this.props.timesheets.timesheet;
    if (timesheet.status !== REJECTED) {
      return "";
    }

    return (
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <b>Remarks:</b>
        </Col>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          {timesheet.remarks}
        </Col>
      </Row>
    );
  };

  getForTSApprovals = () => {
    const forApprovals = this.props.approvals.approvals;

    let arrTimesheetIds = [];

    forApprovals &&
      forApprovals.length &&
      forApprovals.forEach((forApproval) => {
        arrTimesheetIds.push(forApproval.timesheet_id);
      });

    return arrTimesheetIds;
  };

  checkIfBehindCutoff = (status) => {
    const timesheetDates = this.props.timesheets.timesheetDates;
    const timesheet = this.props.timesheets.timesheet;

    let disabledEntries = 0;

    if (status === "Pending" || status === "Approved") {
      this.readOnly = true;
    }

    timesheetDates.forEach((timesheetDate) => {
      const entryDate = timesheetDate.shortHandDate;

      //disable time entries that doesn't reach the cut-off
      const currentDate = moment().date();
      const currentMonth = moment().month() + 1;
      const currentYear = moment().year();

      const entryMonth = moment(entryDate).month() + 1;
      const entryYear = moment(entryDate).year();

      if (timesheet.status === APPROVED) {
        if (entryYear < currentYear) {
          disabledEntries++;
        } else {
          if (currentDate <= 15) {
            if (entryMonth < currentMonth && currentMonth - entryMonth > 1) {
              disabledEntries++;
            }
          } else {
            if (entryMonth < currentMonth) {
              disabledEntries++;
            }
          }
        }
      }
    });
  };

  render() {
    let firstName = "";
    let lastName = "";
    let middleName = "";
    let status = "";
    let user = {};
    let tsr = "";

    if (this.action === "ENTER_TIMESHEET") {
      user = this.props.users.currentUser;
      status = "New";

      if (Object.keys(user).length > 0) {
        firstName = user.first_name;
        lastName = user.last_name;
        middleName = user.middle_name;
      }
    } else {
      //UPDATE_TIMESHEET
      const timesheet = this.props.timesheets.timesheet;

      if (timesheet.requestor) {
        user = timesheet.requestor;
        if (this.action === "UPDATE_TIMESHEET") {
          //check if the user is the owner of the timesheet
          if (user.id !== this.userId) {
            //if the user's role is Org Admin, give readonly access
            if (this.roleId === PORTAL_ADMIN) {
              this.readOnly = true;
            } else {
              // this.props.history.push("/dashboard");
            }
          }
        } else {
          const tsApprovals = this.getForTSApprovals();

          //check if the timesheet is part of the user's timesheet approvals
          if (!tsApprovals.includes(timesheet.timesheet_id)) {
            // this.props.history.push("/dashboard");
          }
        }

        if (Object.keys(user).length > 0 || user) {
          firstName = user.first_name;
          lastName = user.last_name;
          middleName = user.middle_name;
        }
        if (Object.keys(timesheet).length > 0) {
          status = timesheet.status;
        }

        let requestID =
          "TSR" +
          moment(timesheet.start_date).format("YYYYMM") +
          timesheet.timesheet_id.toString().padStart(6, "0");
        tsr = (
          <Row>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
              <span>
                <b>Timesheet Number</b>
              </span>
            </Col>
            <Col xs={10} sm={10} md={10} lg={10} xl={10}>
              <a href={"/#/timesheet/update?id=" + timesheet.timesheet_id}>
                {requestID}
              </a>
            </Col>
          </Row>
        );
      }
    }

    this.status = status;

    if (status === REJECTED) {
      status = status + " - For Revision";
    }

    let weekValue = 0;
    const selectedWeek = this.props.timesheets.selectedWeek;
    if (Object.keys(selectedWeek).length > 0) {
      weekValue = selectedWeek.week_num;
    }

    let weekDisabled = false;

    if (
      this.status === PENDING ||
      this.status === APPROVED ||
      this.status === DRAFT ||
      this.status === REJECTED
    ) {
      weekDisabled = true;
    }

    if (this.props.timesheets.timesheetLoader) {
      return "Loading....";
    }

    let weeksDropdown = (
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <b>Week</b>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <WeeksDropdown
            action={this.action}
            weekValue={weekValue}
            weekDisabled={weekDisabled}
          />
        </Col>
      </Row>
    );

    if (this.status !== NEW) {
      weeksDropdown = "";
    }

    return (
      <>
        {this.generateDateRange()}
        {this.checkIfBehindCutoff(status)}
        <TimesheetConfirmations confirmAction={this.confirmAction} />
        <RequestBudgetForm />
        <PageTitle pageName="Timesheet Request" />
        <Row className="mt-3">
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <span>
              <b>Name</b>
            </span>
          </Col>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <span>
              {lastName}, {firstName} {middleName}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <span>
              <b>Request For*</b>
            </span>
          </Col>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <span>
              {lastName}, {firstName} {middleName}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <span>
              <b>Status</b>
            </span>
          </Col>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <span>{status}</span>
          </Col>
        </Row>
        {tsr}
        {this.displayRemarks()}
        {weeksDropdown}
        {this.renderTimesheetTable()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  timesheets: state.timesheets,
  users: state.users,
  approvals: state.approvals,
  holidays: state.holidays,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    upsertTimesheet: (...args) => dispatch(upsertTimesheet(...args)),
    fetchProjects: () => dispatch(fetchProjects()),
    addTimesheetDate: (...args) => dispatch(addTimesheetDate(...args)),
    addRow: () => dispatch(addRow()),
    enterTimeEntries: (...args) => dispatch(enterTimeEntries(...args)),
    resetTimesheetDates: () => dispatch(resetTimesheetDates()),
    getTimesheetEntries: (...args) => dispatch(getTimesheetEntries(...args)),
    updateTimeEntries: (...args) => dispatch(updateTimeEntries(...args)),
    changeStatus: (...args) => dispatch(changeStatus(...args)),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
    deleteTimeEntryByRow: (...args) => dispatch(deleteTimeEntryByRow(...args)),
    fetchTimesheets: (...args) => dispatch(fetchTimesheets(...args)),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),
    fetchApprovals: (...args) => dispatch(fetchApprovals(...args)),
    setDefaultRole: (...args) => dispatch(setDefaultRole(...args)),
    fetchHolidays: () => dispatch(fetchHolidays()),
    isHoliday: (...args) => dispatch(isHoliday(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddTimesheet)
);
